<template>
    <ul class="dietary-labels list-unstyled" :class="{ large }">
        <li
            v-for="item in itemsWithImage"
            :key="item.value"
            class="item"
            v-test:item
        >
            <lazy-image
                :src="item.image.src"
                :alt="item.text"
                :title="item.text"
                :width="item.image.width"
                :height="item.image.height"
            />
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'dietary-labels',

        props: {
            items: {
                type: Array,
                default: () => ([]),
            },

            large: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            /**
             * Only return dietary labels which have an image.
             *
             * @returns {Array}
             */
            itemsWithImage() {
                return this.items.filter(({ image }) => image?.src);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .dietary-labels {
        display: flex;
        align-items: center;
        margin-left: -3px;
        margin-right: -3px;
    }

    .item {
        padding-left: 3px;
        padding-right: 3px;
        height: 12px;
        @include media-breakpoint-up(md) {
            height: 16px;
        }

    }

    .lazy-image {
        height: 100%;
        width: auto;
        display: block;
    }

    .large {
        &.dietary-labels {
            @include media-breakpoint-up(md) {
                margin-left: -6px;
                margin-right: -6px;
            }
        }

        .item {
            height: 24px;
            @include media-breakpoint-up(md) {
                padding-left: 6px;
                padding-right: 6px;
                height: 44px;
            }
        }
    }
</style>
